import { Module } from "wrapper6";

var $ = jQuery;

export default class SmoothScroll extends Module {

	ready(app) {

		$('a[href*="#"]').on('click', function (e) {
            e.preventDefault()
            let headerHeight = 120;
            if ($(window).width() < 1161) {
              headerHeight = 78
            }
            if ($(window).width() < 581) {
              headerHeight = 58
            }
          
            $('html, body').animate(
              {
                scrollTop: $($(this).attr('href')).offset().top-headerHeight,
              },
              500,
              'linear'
            )
        })

    }
}